var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartStep3Next(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#CED9DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65042 5.492C8.05442 5.492 7.09442 6.476 7.01042 8.24H8.03042C8.05442 7.076 8.65442 6.392 9.65042 6.392C10.5504 6.392 11.1624 6.908 11.1624 7.76C11.1624 8.576 10.4784 9.152 9.47042 9.152C9.30242 9.152 9.18242 9.152 9.08642 9.14V10.004C9.29042 9.98 9.49442 9.968 9.66242 9.968C10.7904 9.968 11.5104 10.592 11.5104 11.6C11.5104 12.56 10.7184 13.244 9.67442 13.244C8.59442 13.244 7.91042 12.584 7.86242 11.372H6.83042V11.408C6.83042 13.172 7.98242 14.144 9.67442 14.144C11.3784 14.144 12.5904 13.136 12.5904 11.552C12.5904 10.472 12.0624 9.716 11.0544 9.488V9.464C11.8224 9.092 12.2304 8.456 12.2304 7.76C12.2304 6.356 11.2704 5.492 9.65042 5.492Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartStep3Next);
export default __webpack_public_path__ + "static/media/CartStep3Next.667a3105a8f750960d6bcacf878623c0.svg";
export { ForwardRef as ReactComponent };